module.exports = __webpack_public_path__ + "img/Deathknight-tauren-m-70.b9ae5b38.gif";